module.exports = __webpack_public_path__ + "fonts/PTN57F-webfont.4b20cf6.woff";